<kendo-dialog-titlebar>
    {{'shared.header.addNewCarModel' | translate}}
</kendo-dialog-titlebar>

<div *ngIf="!!selectedBrand" fxLayout="column" fxLayoutGap="15px">
    <span>{{'shared.header.addNewCarModelForBrand' | translate}}</span><strong>{{selectedBrand}} </strong>
    <form [formGroup]="dataForm">
        <text-input-ctrl [caption]="'shared.modelName'" [formControlName]="'value'" [settings]="{fxFill:true,uppercase:true}"></text-input-ctrl>
    </form>

    <div fxLayoutAlign="center center" fxLayoutGap="15px">
        <button type="button" kendoButton (click)="cancel()">{{'global.cancel' | translate}}</button>
        <button type="button" kendoButton (click)="confirm()" [primary]="true">
            <span>{{'global.add' | translate}}</span>
        </button>
    </div>
</div>

<div *ngIf="!selectedBrand">
    <h3>{{'errors.brandMustBeSelectedToDefineNewModel' | translate}}</h3>
</div>